import { Component } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

// The small "малку податоци" pill (CLIPPING-threshold, 2026-10-25): shown next to a number/bar
// that IS real and shown in full, just computed from under LOW_DATA_THRESHOLD mentions - never a
// replacement for the value itself (see analytics-request.util.ts's isLowDataCount). Hover explains
// why via matTooltip, same "wide-tooltip" pattern as InfoIconComponent.
@Component({
	selector: 'app-low-data-badge',
	standalone: true,
	imports: [MatTooltipModule, TranslateModule],
	template: `<span class="low-data-badge" matTooltipClass="wide-tooltip" matTooltipPosition="above" [matTooltip]="'ANALYTICS_GLOSSARY.LOW_DATA_TOOLTIP' | translate">{{
		'ANALYTICS_GLOSSARY.LOW_DATA_BADGE' | translate
	}}</span>`,
	styles: [
		`
			.low-data-badge {
				display: inline-flex;
				align-items: center;
				padding: 0 5px;
				height: 14px;
				border-radius: 999px;
				font-size: 9px;
				font-weight: 500;
				line-height: 14px;
				background: var(--surface-gray, #eef0f3);
				color: var(--ink-subtle, #5f6470);
				cursor: help;
				vertical-align: middle;
				white-space: nowrap;
			}
		`,
	],
})
export class LowDataBadgeComponent {}
